import { Disclosure } from "@headlessui/react";
import snakeCase from "lodash/fp/snakeCase";
import React, {
  ComponentPropsWithoutRef,
  FunctionComponent,
  useState,
} from "react";
import ChevronDownIcon from "shared/components/icons/chevron/ChevronDownIcon";

export type MenuItemDisclosureProps = {
  label: string;
  initialIsOpen: boolean;
  children: React.ReactNode;
  panelClassName?: string;
  buttonClassName?: string;
  chevronIconClassname?: string;
  className?: string;
  IconComponent?: FunctionComponent<ComponentPropsWithoutRef<"svg">>;
};

const HubSideMenuItem = ({
  label,
  initialIsOpen = false,
  children,
  buttonClassName,
  panelClassName,
  chevronIconClassname,
  className,
  IconComponent,
}: MenuItemDisclosureProps) => {
  const [panelIsOpen, setPanelIsOpen] = useState<boolean>(initialIsOpen);

  return (
    <Disclosure as="div" className={className}>
      {() => (
        <>
          <Disclosure.Button
            data-testid={`main-menu-${snakeCase(label)}`}
            className={`sidebar-menu-selector ${buttonClassName}`}
            onClick={() => setPanelIsOpen((prev) => !prev)}
          >
            {IconComponent && (
              <IconComponent className="sidebar-menu-svg ion-like-icon" />
            )}
            <div className="sidebar-menu-title">{label}</div>
            <span>
              <ChevronDownIcon
                className={`${
                  panelIsOpen ? "rotate-180 transform" : ""
                } ${chevronIconClassname}`}
              />
            </span>
          </Disclosure.Button>
          <Disclosure.Panel className={panelClassName}>
            {children}
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
};

export default HubSideMenuItem;
